import { render, staticRenderFns } from "./MainMenu.vue?vue&type=template&id=731598b5"
import script from "./MainMenu.vue?vue&type=script&lang=ts"
export * from "./MainMenu.vue?vue&type=script&lang=ts"
import style0 from "./MainMenu.vue?vue&type=style&index=0&id=731598b5&prod&lang=scss&scopped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports